import { Link } from 'react-router';
import { Button } from '@britishcouncil/react-admin';
import { usePermissions } from '@britishcouncil/react-common';

import { EorMonitoringResultEnum, EorSpeakingMonitoringGroup, Permission } from 'api';
import { ActionsCell, ViewDetailsButton } from 'components';

interface EorSpeakingMonitoringActionsProps {
  monitoringGroup: EorSpeakingMonitoringGroup;
}

const canAddNewStage = (monitoringGroup: EorSpeakingMonitoringGroup): boolean => {
  return (
    !monitoringGroup.isDeleted &&
    monitoringGroup.monitorings.length < 3 &&
    !monitoringGroup.monitorings.some((x) => x.result.id === EorMonitoringResultEnum.Standard)
  );
};

export const EorSpeakingMonitoringActions = ({
  monitoringGroup,
}: EorSpeakingMonitoringActionsProps) => {
  const { permissions } = usePermissions();
  const hasUpdatePermission = permissions.includes(Permission.UpdateEorMonitoringResults);
  const showAddButton = canAddNewStage(monitoringGroup) && hasUpdatePermission;

  return (
    <ActionsCell>
      <ViewDetailsButton to={monitoringGroup.id} />
      {showAddButton && (
        <Button
          as={Link}
          to={`${monitoringGroup.id}/add`}
          primary
          icon="plus"
          circular
          title="Add new stage"
          size="mini"
        />
      )}
    </ActionsCell>
  );
};
